import React, { useMemo, useState } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { hu } from '../../lib/portalApi';

const PCT = [100, 95, 90, 85, 80, 75, 70, 65, 60];
const REPS_AT = { 100: 1, 95: 2, 90: 4, 85: 6, 80: 8, 75: 10, 70: 12, 65: 15, 60: 18 };

export const OneRmTab = () => {
  const [kg, setKg] = useState(100);
  const [reps, setReps] = useState(5);

  const orm = useMemo(() => {
    const w = Number(kg) || 0;
    const r = Number(reps) || 0;
    if (!w || !r) return null;
    const epley = r === 1 ? w : w * (1 + r / 30);
    const brzycki = r < 37 ? w * (36 / (37 - r)) : epley;
    return {
      epley: Math.round(epley * 10) / 10,
      brzycki: Math.round(brzycki * 10) / 10,
      avg: Math.round(((epley + brzycki) / 2) * 10) / 10,
    };
  }, [kg, reps]);

  return (
    <div data-testid="onerm-tab" className="grid lg:grid-cols-2 gap-6">
      <div className="bg-white border border-gray-200 rounded-xl p-5">
        <h3 className="text-[11px] font-black uppercase tracking-[0.14em] text-gray-500 mb-4">
          Becsült maximum (1RM)
        </h3>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-[11px] uppercase tracking-wider text-gray-500">Súly (kg)</Label>
            <Input data-testid="onerm-kg" type="number" value={kg} onChange={e => setKg(e.target.value)} className="mt-1" />
          </div>
          <div>
            <Label className="text-[11px] uppercase tracking-wider text-gray-500">Ismétlés</Label>
            <Input data-testid="onerm-reps" type="number" min="1" max="15" value={reps}
              onChange={e => setReps(Math.min(15, Math.max(1, Number(e.target.value) || 1)))} className="mt-1" />
          </div>
        </div>
        {orm && (
          <div className="mt-4 grid grid-cols-3 gap-3">
            <div className="rounded-lg bg-gray-900 text-white p-3">
              <div className="text-[10px] uppercase tracking-wider text-gray-400">Átlag 1RM</div>
              <div className="text-2xl font-black" data-testid="onerm-result">{hu(orm.avg, 1)}</div>
              <div className="text-[11px] text-gray-400">kg</div>
            </div>
            <div className="rounded-lg bg-gray-50 p-3">
              <div className="text-[10px] uppercase tracking-wider text-gray-500">Epley</div>
              <div className="text-xl font-black text-gray-900">{hu(orm.epley, 1)}</div>
            </div>
            <div className="rounded-lg bg-gray-50 p-3">
              <div className="text-[10px] uppercase tracking-wider text-gray-500">Brzycki</div>
              <div className="text-xl font-black text-gray-900">{hu(orm.brzycki, 1)}</div>
            </div>
          </div>
        )}
        <p className="text-xs text-gray-500 mt-4 leading-relaxed">
          A becslés 1–10 ismétlés között a legpontosabb. Erőgyakorlatoknál (guggolás, fekvenyomás,
          felhúzás) használd, izolációs gyakorlatra ne.
        </p>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-5">
        <h3 className="text-[11px] font-black uppercase tracking-[0.14em] text-gray-500 mb-4">
          Edzőtáblázat (% × 1RM)
        </h3>
        {!orm ? (
          <p className="text-sm text-gray-500">Add meg a súlyt és az ismétlést.</p>
        ) : (
          <table className="w-full text-sm" data-testid="onerm-table">
            <thead>
              <tr className="text-[10px] uppercase tracking-wider text-gray-500 border-b border-gray-200">
                <th className="text-left py-2">%</th>
                <th className="text-right py-2">Súly</th>
                <th className="text-right py-2">Kb. ismétlés</th>
              </tr>
            </thead>
            <tbody>
              {PCT.map(p => (
                <tr key={p} className="border-b border-gray-100">
                  <td className="py-2 font-semibold text-gray-900">{p}%</td>
                  <td className="py-2 text-right font-black text-gray-900">
                    {hu(Math.round((orm.avg * p) / 100 * 2) / 2, 1)} kg
                  </td>
                  <td className="py-2 text-right text-gray-600">{REPS_AT[p]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default OneRmTab;
